import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  const SITE_URL = import.meta.env.VITE_SITE_URL ?? 'https://greenlyelectronicsrecycling.com';

  return (
    <>
      <title>404 — Page Not Found | Greenly Electronics Recycling</title>
      <meta name="description" content="Page not found. Greenly Electronics Recycling — Los Angeles certified electronics recycler. TV recycling, computer recycling, battery recycling, data destruction & hard drive shredding." />
      <meta name="robots" content="noindex, follow" />
      <link rel="canonical" href={`${SITE_URL}/404.html`} />

      <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-[#f8faf8]">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-[#e8f0eb] select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10">
          <h2 className="text-xl md:text-2xl font-semibold mt-6 text-gray-900">Page Not Found</h2>
          <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
          <p className="mt-4 text-lg md:text-xl text-gray-500">
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>
          <a
            href="/"
            className="inline-flex items-center gap-2 bg-[#1B6B3A] hover:bg-[#2D8653] text-white font-semibold px-6 py-3 rounded-lg transition-colors cursor-pointer mt-6"
          >
            <i className="ri-home-line"></i>
            Back to Home
          </a>
        </div>
      </div>
    </>
  );
}
